import { useState, useMemo } from 'react'
import { Typography, Card, Tabs, TabsHeader, Tab, Button } from '@material-tailwind/react'
import { HasAccess } from '@permify/react-role'
import { VisitInviteForm } from './invite-form'
import { VisitApprovals } from './approvals'
import { VisitActive } from './active'
import { VisitHistory } from './history'

const ALL_TABS = ['invitar', 'aprobar', 'vigentes', 'historial']

export default function VisitHome() {
  const [active, setActive] = useState('invitar') // invitar | aprobar | vigentes | historial

  const currentCategory = useMemo(
    () => (active === 'invitar' || active === 'aprobar' ? 'todo' : 'log'),
    [active]
  )

  const goCategory = (cat) => {
    // al cambiar de categoría en mobile, saltamos al primer subtab de cada una
    setActive(cat === 'todo' ? 'invitar' : 'vigentes')
  }

  const renderBody = () => {
    switch (active) {
      case 'invitar':   return <VisitInviteForm />
      case 'aprobar':   return <VisitApprovals />
      case 'vigentes':  return <VisitActive />
      case 'historial': return <VisitHistory />
      default:          return null
    }
  }

  return (
    <div className="mx-auto w-full p-3 sm:p-6">
      <div className="mb-4">
        <Typography variant="h4" className="mb-1">Visitas</Typography>
        <Typography variant="small" className="text-gray-600">
          Gestiona invitaciones y autorizaciones de acceso.
        </Typography>
      </div>

      <Card className="p-3 w-full">
        {/* ===== DESKTOP: una sola fila con 4 tabs ===== */}
        <div className="hidden sm:block">
          <Tabs value={active}>
            <TabsHeader
              className="bg-transparent border-b border-gray-200"
              indicatorProps={{
                className: 'bg-blue-600/80 h-[2px] rounded-none',
              }}
            >
              <Tab
                value="invitar"
                onClick={() => setActive('invitar')}
                className="text-gray-700 font-medium data-[state=active]:text-blue-700"
              >
                Invitar
              </Tab>
              <HasAccess permissions="visit#approve">
                <Tab
                  value="aprobar"
                  onClick={() => setActive('aprobar')}
                  className="text-gray-700 font-medium data-[state=active]:text-blue-700"
                >
                  Aprobar
                </Tab>
                <Tab
                  value="vigentes"
                  onClick={() => setActive('vigentes')}
                  className="text-gray-700 font-medium data-[state=active]:text-blue-700"
                >
                  Vigentes
                </Tab>
                <Tab
                  value="historial"
                  onClick={() => setActive('historial')}
                  className="text-gray-700 font-medium data-[state=active]:text-blue-700"
                >
                  Historial
                </Tab>
              </HasAccess>
            </TabsHeader>
          </Tabs>
        </div>

        {/* ===== MOBILE: categoría + subtabs como botones ===== */}
        <div className="sm:hidden">
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => goCategory('todo')}
              className={`px-4 py-2 rounded-full font-medium transition shadow-sm ${
                currentCategory === 'todo' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-800'
              }`}
            >
              Por hacer
            </button>
            <button
              type="button"
              onClick={() => goCategory('log')}
              className={`px-4 py-2 rounded-full font-medium transition shadow-sm ${
                currentCategory === 'log' ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-800'
              }`}
            >
              Registros
            </button>
          </div>

          {/* Sub-botones: envoltorio flexible */}
          <div className="mt-3 flex flex-wrap gap-2">
            {currentCategory === 'todo' ? (
              <>
                <Button
                  size="sm"
                  className={`${active === 'invitar' ? 'bg-blue-500 text-white' : 'bg-white text-gray-800 border'} grow basis-[45%]`}
                  onClick={() => setActive('invitar')}
                >
                  Invitar
                </Button>
                <HasAccess permissions="visit#approve">
                  <Button
                    size="sm"
                    className={`${active === 'aprobar' ? 'bg-blue-500 text-white' : 'bg-white text-gray-800 border'} grow basis-[45%]`}
                    onClick={() => setActive('aprobar')}
                  >
                    Aprobar
                  </Button>
                </HasAccess>
              </>
            ) : (
              <HasAccess permissions="visit#approve">
                <>
                  <Button
                    size="sm"
                    className={`${active === 'vigentes' ? 'bg-green-500 text-white' : 'bg-white text-gray-800 border'} grow basis-[45%]`}
                    onClick={() => setActive('vigentes')}
                  >
                    Vigentes
                  </Button>
                  <Button
                    size="sm"
                    className={`${active === 'historial' ? 'bg-green-500 text-white' : 'bg-white text-gray-800 border'} grow basis-[45%]`}
                    onClick={() => setActive('historial')}
                  >
                    Historial
                  </Button>
                </>
              </HasAccess>
            )}
          </div>
        </div>

        {/* ===== Contenido ===== */}
        <div className="mt-4">
          {renderBody()}
        </div>
      </Card>
    </div>
  )
}